import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAditivosRecursoRecebidoInicio: [],
    buscaAditivosRecursoRecebidoSucesso: ['aditivosRecursoRecebido'],
    buscaAditivosRecursoRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAditivosRecursoRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaAditivosRecursoRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarAditivos(filtro)
            .then(response => dispatch(Creators.buscaAditivosRecursoRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAditivosRecursoRecebidoErro(error)))
    }
}

const buscaAditivosRecursoRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaAditivosRecursoRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaAditivosRecursoRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.aditivosRecursoRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ADITIVOS_RECURSO_RECEBIDO_INICIO]: buscaAditivosRecursoRecebidoInicio,
    [Types.BUSCA_ADITIVOS_RECURSO_RECEBIDO_ERRO]: buscaAditivosRecursoRecebidoErro,
    [Types.BUSCA_ADITIVOS_RECURSO_RECEBIDO_SUCESSO]: buscaAditivosRecursoRecebidoSucesso,
})
